import { render, staticRenderFns } from "./AsignacionBusqueda.vue?vue&type=template&id=b740e982&"
import script from "./AsignacionBusqueda.vue?vue&type=script&lang=ts&"
export * from "./AsignacionBusqueda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b740e982', component.options)
    } else {
      api.reload('b740e982', component.options)
    }
    module.hot.accept("./AsignacionBusqueda.vue?vue&type=template&id=b740e982&", function () {
      api.rerender('b740e982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/AsignacionBusqueda.vue"
export default component.exports